import { render } from "./Index.vue?vue&type=template&id=556ebd90&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=556ebd90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-556ebd90"

export default script